function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function DocumentWTick(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.734 1c.797 0 1.548.31 2.114.872l4.265 4.234v.001c.573.568.887 1.324.887 2.13V20c0 1.654-1.406 3-3.134 3H6.133C4.405 23 3 21.654 3 20V4c0-1.654 1.405-3 3.133-3h7.601zm-.694 2H6.133C5.508 3 5 3.448 5 4v16c0 .552.508 1 1.133 1h11.733c.625 0 1.134-.448 1.134-1V8.644h-2.96c-1.654 0-3-1.345-3-3V3zm2.978 8.164a.999.999 0 01-.005 1.414l-4.317 4.28a.998.998 0 01-.704.29h-.006a1 1 0 01-.706-.3l-2.302-2.337a1 1 0 011.425-1.402l1.598 1.622 3.603-3.573a1 1 0 011.414.006zm1.8-4.52L15.04 3.888v1.757a1 1 0 001 1h1.777z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoDocumentWTick = /*#__PURE__*/React.memo(DocumentWTick);
export default MemoDocumentWTick;